import React, { useCallback, useState, useRef } from "react";
import { debounce } from "lodash";
import { SearchInput } from "@ddm-design-system/textinput";
import useContent from "../../../hooks/useContent";
import "./filter.scss";

interface IProps {
  onFilterChange?: (text: string) => void;
}
export const Filter: React.FC<IProps> = ({ onFilterChange }) => {
  const { managerAppSettings: contentSettings } = useContent();
  const [filterText, setFilterText] = useState("");

  const debouncedOnFilterChange = useRef(
    debounce((text: string) => {
      onFilterChange?.(text);
    }, 250)
  ).current;

  const setFilter = useCallback(
    (text: string) => {
      setFilterText(text);
      debouncedOnFilterChange(text);
    },
    [debouncedOnFilterChange]
  );

  return (
    <SearchInput
      className="filter"
      value={filterText}
      label={contentSettings.manager_app_settings_user_filter_description}
      onChange={e => {
        setFilter(e.target.value);
      }}
    />
  );
};
export default Filter;
